/**
 * @module Infogram
 * @description Basically a shortcode
 * @example Map: <infogram-widget id="infogram_0_a8b70daa-ac14-48d8-9011-1bf66586b142" title="Avg car insurance cost by state"></infogram-widget>
 * @example Chart: <infogram-widget id="infogram_0_5af8e23e-6863-41f3-a798-4c2b675fa554" title="Avg car insurance premium by gender"></infogram-widget>
 */

export class InfogramWidget extends HTMLElement {
  constructor() {
    super();

    this.attrs = {
      id: '',
      src: '',
      title: '',
      type: ''
    }
  }

  /**
   * @function loadScript
   * @description Build & Load our script
   */
  loadScript() {
    const script = document.createElement( 'script' );
    script.id = this.attrs.id;
    script.src = this.attrs.src;
    script.title = this.attrs.title;
    script.type = this.attrs.type;
    script.async = true;

    this.appendChild( script );
  }

  /**
   * @function lazyLoad
   * @description Lazy load our script
   */
  lazyLoad() {
     const options = {
       root: null,
       trackVisibility: true,
       delay: 100,
       rootMargin: '0px',
       threshold: 0
     };

     const observer = new IntersectionObserver( ( entries ) => {
       const entry = entries[ 0 ]; // should only ever be 1 hero.

       if ( entry.isVisible === false && entry.isIntersecting === false && entry.intersectionRatio === 0 ) {
         this.loadScript();

         // Disconnect the observer and call our event
         observer.disconnect();
       }
     }, options );

     let target = document.querySelector( '.article-hero__headline' );

     if( ! target ) {
       target = document.querySelector( '.hub-hero' );

       if( ! target ) {
         return;
       }
     }

     observer.observe( target );
   };

  /**
   * @function connectedCallback
   * @description WebComponent Connected
   */
  connectedCallback() {
    this.attrs.id = this.hasAttribute( 'id' ) ? this.getAttribute( 'id' ) : '';
    this.attrs.src = this.hasAttribute( 'src' ) ? this.getAttribute( 'src' ) : 'https://e.infogram.com/js/dist/embed.js?Myc';
    this.attrs.title = this.hasAttribute( 'title' ) ? this.getAttribute( 'title' ) : '';
    this.attrs.type = this.hasAttribute( 'type' ) ? this.getAttribute( 'type' ) : 'text/javascript';

    this.lazyLoad();
  }
}

customElements.define( 'infogram-widget', InfogramWidget );
